import { atom } from "jotai";

export const pjAtom = atom(null);
export const isPjLoadingAtom = atom(false);
export const bottomPanelContentAtom = atom(null);
export const isSearchingFilesAtom = atom(null);
export const isFilesLoadedAtom = atom(false);
